import { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const propTypes = {
  cohorts: PropTypes.objectOf(PropTypes.any).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const CohortsDropdown = ({ cohorts, value, onChange }) => {
  const [cohortsMenuItems, setCohortsMenuItems] = useState([]);

  useEffect(() => {
    const cohortsEntries = Object.entries(cohorts);
    cohortsEntries.sort((a, b) => {
      if (a[1].name < b[1].name) return -1;
      if (a[1].name > b[1].name) return 1;
      return 0;
    });
    const menuItems = cohortsEntries.map(([id, cohort]) => {
      return (
        <MenuItem key={id} value={id}>
          {cohort.name}
        </MenuItem>
      );
    });
    setCohortsMenuItems(menuItems);
  }, [cohorts]);

  return (
    cohortsMenuItems.length > 0 && (
      <FormControl fullWidth>
        <InputLabel id="cohort-label">Cohort</InputLabel>
        <Select
          labelId="cohort-label"
          id="cohort-select"
          value={value}
          label="Cohort"
          onChange={onChange}
        >
          {cohortsMenuItems}
        </Select>
      </FormControl>
    )
  );
};

CohortsDropdown.propTypes = propTypes;

export default CohortsDropdown;
